/* eslint-disable */
// TODO: Lint cleanup. If you are editing this file, it is your duty to fix all linting errors.
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import throttle from 'lodash/throttle'
import session from 'modules/session'

import makeRootReducer from './reducers'

export let storeInstance = null

export default (initialState = {}, extras = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk.withExtraArgument(extras)]

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = []
  if (__DEBUG__) {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__
    if (typeof __REDUX_DEVTOOLS_EXTENSION__ === 'function') {
      enhancers.push(devToolsExtension())
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    compose(
      applyMiddleware(...middleware),
      ...enhancers
    )
  )
  store.asyncReducers = {}

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  store.subscribe(
    throttle(() => {
      session.utils.saveState({
        session: store.getState().session,
      })
    }, 1000)
  )

  storeInstance = store
  return store
}
